<!--<c-footer>-->
<div class="w-100 d-flex flex-wrap justify-content-center justify-content-md-between align-items-center gap-1 text-center px-2">
  <div>
    <a href='https://depromos.cl/' target="_blank" rel="noopener">Depromos</a>
    <span>&copy; 2026</span>
  </div>
  <div>
    Powered by
    <a href='https://depromos.cl' target="_blank" rel="noopener">Depromos</a>
  </div>
</div>
<!--</c-footer>-->
